<template>
  <div class="pa-2">
    <h1 class="title grey--text font-weight-light">
      Failed to retrieve the scope information.
    </h1>
    <h2 class="subtitle-2 font-weight-light">
      The scope could not exists or the server is down.
    </h2>
  </div>
</template>

<script>
import { Scope, Permission } from '@/api';
import { getPermission } from '@/utils';
import store from '@/store';

export default {
  name: 'business-scope.redirect',
  data() {
    return {
      loading: true,
    };
  },
  async beforeRouteEnter(to, _, next) {
    const { data: scope } = await Scope.fetch({ name: to.params.scope });
    const { data: permissions } = await Permission.me(to.query.email);
    const { data: groups } = await Permission.group(to.query.email);

    const groupPermission = groups.reduce((acc, item) => {
      // eslint-disable-next-line
      if (item.length) acc = acc.concat(item);
      return acc;
    }, []);

    const iotAccess = (
      getPermission(permissions, 'iot')
      || getPermission(groupPermission, 'iot')
    );
    const dynamicItineraryAccess = (
      getPermission(permissions, 'dynamicitineraryaccess')
      || getPermission(groupPermission, 'dynamicitineraryaccess')
    );

    if (iotAccess) {
      store.commit('IOT_ACCESS', !!iotAccess);
    }

    if (dynamicItineraryAccess) {
      store.commit('DYNAMIC_ITINERARY_ACCESS', !!dynamicItineraryAccess);
    }

    if (scope) {
      next({
        name: 'business-scope.search',
        params: { scope: scope.guid },
      });
    } else {
      next();
    }
  },
};
</script>
